<div class="sk-upshop-loading-indicator">
	<div #shape0 class="sk-upshop-loading-indicator__masked">
		<div class="sk-upshop-loading-indicator__anchor sk-upshop-loading-indicator__anchor--0">
			<div #spin0 class="sk-upshop-loading-indicator__spin sk-upshop-loading-indicator__spin--rev"></div>
		</div>
	</div>
	<div #shape1 class="sk-upshop-loading-indicator__masked">
		<div class="sk-upshop-loading-indicator__anchor sk-upshop-loading-indicator__anchor--1">
			<div #spin1 class="sk-upshop-loading-indicator__spin sk-upshop-loading-indicator__spin--fwd"></div>
		</div>
	</div>
</div>
